import { Vue, Component, Watch } from 'vue-property-decorator';
import axios from 'axios';
import VueUploadMultipleImage from 'vue-upload-multiple-image';
import VuePureLightbox from 'vue-pure-lightbox';
import { documentobjrmastatus } from './RmaStatus.services'
import { consoleError } from 'vuetify/src/util/console';
// import MarqueeText from 'vue-marquee-text-component';
import { VueScrollTo } from 'vue-scrollto';

@Component({
    components:{
        VueUploadMultipleImage,
        VuePureLightbox,
//        MarqueeText
    }
})
export default class RmaStatus extends Vue {
    public rmaNumber :any;
    public rmaStatus :any;
    public allDetails : any;
    public changeStatus:any;
    public rmaOutcome : any;
    public date_issued :any;
    public date_approved :any;
    public date_updated  :any;
    public refundAmount:any;
    public images:any;
    public comment:any;
    public file: any;
    public errorMessage: string = '';
    public successMessage: string ='';
    public formData : any;
    public Images : any[] = [];
    public imageUpload : any;
    public r_id : any;
    public buttonDisabled:boolean =false;
    public submitted: boolean = false;
    public rma_number : any;
    public dialog : any;
    public save_dialog : any;
    public data(){
        return{
            save_dialog : false,
            rma_number:'',
            r_id : '',
            submitted: false,
            rmaNumber : '',
            rmaStatus : '',
            allDetails : '',
            changeStatus:'',
            rmaOutcome:'',
            errorMessage: '',
            successMessage:'',
            refundAmount:'',
            comment:'',
            buttonDisabled:false,
            formData:'',
            imageUpload :'',
            Images : [],
            date_approved : '',
            date_issued:'',
            date_updated:'',
            file:[],
            dialog: false,
        }
    }   
    beforeMount(){
        window.scrollTo(0,0);
    }
    mounted() {
        let r_id = localStorage.getItem("RmaID");
        localStorage.removeItem("RmaID");
        if(r_id){
            let postData={
               r_id : r_id
            }
            this.getDetailsOnPageLoad(postData);
        }
        // console.log(r_id)
    }
    getDetailsOnPageLoad(data){
        const response = documentobjrmastatus.DetailsDisplayOnPageLoad(data).then((res:any) =>{
            console.log(res);
            this.date_approved = res.data.data.date_approved;
            this.date_issued = res.data.data.date_issued;
            this.date_updated = res.data.data.date_updated;
            this.rmaStatus = res.data.data.rma_status;
            this.rma_number = res.data.data.rma_number;
        }).catch((err:any)=>{
            console.log(err);
        })
    }
    CancelRmaButton(){
        this.dialog = false
        this.$router.push('/rma-list');
    }
    // function to be called onclick of close RMA buttond
    CloseRmaButton(){
        console.log(this.rma_number)
        let postData :any;
        if(this.rma_number){
            postData={
                'data':{
                    r_id:this.rma_number,
                    button:'Closed'
                }
            }
        }else{
            this.save_dialog = true;
        }    
        console.log('postData in Closerma button click')
        // console.log(postData)
        this.getDocumentCloseRma(postData)
    }
    MarkRmaButton(){
        let postData : any;
        if(this.rma_number){
            postData={
                'data':{
                    r_id:this.rma_number,
                    button: 'Resolved'
                }
            }
        }else{
            this.save_dialog = true;
        }    
        console.log('postData in Markrma button click')
        // console.log(postData)
        this.getDocumentCloseRma(postData)
    }
    // post API calling on close rma button click
    public async getDocumentCloseRma(data:any){
        // console.log("Post API call for closerma button")
        const respponse = documentobjrmastatus.CloseRmaPostApi(data).then((res:any)=>{
            console.log(res.data.data.rma_status);
            this.rmaStatus = res.data.data.rma_status;
            let variant = 'success';
            this.$bvToast.toast('RMA Status Saved as ' + res.data.data.rma_status, {
                  title: 'RMA Status Saved',
                  autoHideDelay: 1500,
                  variant: variant,
                  solid: true
            });
        })
    }
    // function calling on save button click
    RmaStatusSave(){
        let form = <any>document.getElementById("form_id") as HTMLFormElement;
        let formData = new FormData(form)
        if(this.file.length > 0){
            for (var i = 0; i < this.file.length; i++) {
                var file_id = this.file[i];
                // Add the file to the request.
                formData.append('document_list', file_id, file_id.name);
            }
        }
        
        this.submitted = true;
        this.$validator.validate().then(valid => {
            if (valid) {
                console.log("RmaStatusSave")
                this.getDocumentAddSkuStatus(formData)
            }else{
                console.log('Not Valid Fields')
                if(!this.rma_number){
                    this.save_dialog = true
                }
                this.buttonDisabled = false;
            }
        });
    }
    // post API calling of "save" button click
    public async getDocumentAddSkuStatus(data:any){
        const response = documentobjrmastatus.NewRmaStatusSavePost(data).then((res: any) =>{
            console.log(res);
            let variant = 'success';
            this.$bvToast.toast('RMA Details Saved successfully !', {
                  title: 'Add RMA',
                  autoHideDelay: 1500,
                  variant: variant,
                  solid: true
            });
        }).catch((err: any) =>{
            console.log(err);
        })

    }
    // file upload formdata handling function
    handleFileUpload(){
        this.file = document.getElementById('document') as HTMLElement;
        this.file = this.file.files;
        // this.file = this.$refs.file.files[0];
        this.successMessage = '';
        this.errorMessage = '';
    }
}

